import { render } from "./StockComponent.vue?vue&type=template&id=6d386fea"
import script from "./StockComponent.vue?vue&type=script&lang=js"
export * from "./StockComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/stock/StockComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d386fea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d386fea', __exports__)) {
    api.reload('6d386fea', __exports__)
  }
  
  module.hot.accept("./StockComponent.vue?vue&type=template&id=6d386fea", () => {
    api.rerender('6d386fea', render)
  })

}


export default __exports__